// Estados de México y sus municipios/ciudades más relevantes para una
// agencia de viajes (capital + ciudades turísticas/económicas principales).
// No es una lista exhaustiva a propósito — sirve como sugerencia rápida en
// el campo de municipio, que sigue siendo texto libre para cualquier otro.
export const MX_STATES = [
  "Aguascalientes", "Baja California", "Baja California Sur", "Campeche",
  "Chiapas", "Chihuahua", "Ciudad de México", "Coahuila", "Colima", "Durango",
  "Guanajuato", "Guerrero", "Hidalgo", "Jalisco", "México", "Michoacán",
  "Morelos", "Nayarit", "Nuevo León", "Oaxaca", "Puebla", "Querétaro",
  "Quintana Roo", "San Luis Potosí", "Sinaloa", "Sonora", "Tabasco",
  "Tamaulipas", "Tlaxcala", "Veracruz", "Yucatán", "Zacatecas",
];

export const MX_TOP_MUNICIPALITIES = {
  "Aguascalientes": ["Aguascalientes", "Jesús María", "Calvillo"],
  "Baja California": ["Tijuana", "Mexicali", "Ensenada", "Rosarito"],
  "Baja California Sur": ["La Paz", "Los Cabos", "Comondú"],
  "Campeche": ["Campeche", "Ciudad del Carmen"],
  "Chiapas": ["Tuxtla Gutiérrez", "San Cristóbal de las Casas", "Tapachula", "Palenque"],
  "Chihuahua": ["Chihuahua", "Ciudad Juárez", "Cuauhtémoc"],
  "Ciudad de México": ["Cuauhtémoc", "Miguel Hidalgo", "Benito Juárez", "Coyoacán"],
  "Coahuila": ["Saltillo", "Torreón", "Monclova", "Piedras Negras"],
  "Colima": ["Colima", "Manzanillo"],
  "Durango": ["Durango", "Gómez Palacio"],
  "Guanajuato": ["León", "Guanajuato", "Irapuato", "San Miguel de Allende", "Celaya"],
  "Guerrero": ["Acapulco", "Chilpancingo", "Zihuatanejo", "Taxco"],
  "Hidalgo": ["Pachuca", "Tulancingo", "Huejutla"],
  "Jalisco": ["Guadalajara", "Zapopan", "Puerto Vallarta", "Tlaquepaque"],
  "México": ["Toluca", "Ecatepec", "Naucalpan", "Metepec"],
  "Michoacán": ["Morelia", "Uruapan", "Pátzcuaro", "Zamora"],
  "Morelos": ["Cuernavaca", "Cuautla"],
  "Nayarit": ["Tepic", "Bahía de Banderas", "Nuevo Vallarta"],
  "Nuevo León": ["Monterrey", "San Pedro Garza García", "Guadalupe", "San Nicolás de los Garza"],
  "Oaxaca": ["Oaxaca de Juárez", "Huatulco", "Puerto Escondido"],
  "Puebla": ["Puebla", "Cholula", "Tehuacán"],
  "Querétaro": ["Querétaro", "San Juan del Río"],
  "Quintana Roo": ["Cancún", "Playa del Carmen", "Tulum", "Cozumel", "Chetumal"],
  "San Luis Potosí": ["San Luis Potosí", "Ciudad Valles"],
  "Sinaloa": ["Culiacán", "Mazatlán", "Los Mochis"],
  "Sonora": ["Hermosillo", "Ciudad Obregón", "Nogales", "Puerto Peñasco"],
  "Tabasco": ["Villahermosa", "Cárdenas"],
  "Tamaulipas": ["Tampico", "Reynosa", "Matamoros", "Nuevo Laredo"],
  "Tlaxcala": ["Tlaxcala", "Apizaco"],
  "Veracruz": ["Veracruz", "Xalapa", "Coatzacoalcos", "Boca del Río"],
  "Yucatán": ["Mérida", "Valladolid", "Progreso"],
  "Zacatecas": ["Zacatecas", "Fresnillo"],
};
